export default __webpack_public_path__ + "static/media/CheckedMobile.e4340225.svg";